import React from 'react';

const style = {
  display: 'inline-block',
  userSelect: 'none',
  flexShrink: 0,
};

const CheckIcon = ({ type = 'large', color = 'black', style: overrideStyles = {}, ...attr }) => {
  if (type === 'textInlined') {
    return (
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M4.93478 8.5L4.38092 9.0057L4.93478 9.61232L5.48865 9.0057L4.93478 8.5ZM8.94614 2.9943L4.38092 7.9943L5.48865 9.0057L10.0539 4.0057L8.94614 2.9943ZM5.48865 7.9943L3.05386 5.32763L1.94614 6.33904L4.38092 9.0057L5.48865 7.9943Z" fill={color} />
      </svg>
    );
  }

  const width = type === 'small' ? 11 : 13;
  const height = type === 'small' ? 10 : 12;

  return (
    <svg
      style={{ ...style, ...overrideStyles }}
      width={width}
      height={height}
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...attr}
    >
      {type === 'small' && <path d="M1 4.8L5.01739 9L9.8 1" stroke={color} />}
      {type !== 'small' && <path d="M1 5.75L6.02174 11L12 1" stroke={color} />}
    </svg>
  );
};

export default CheckIcon;
